/** Generated from direct page/layout role guards by doc48-settings-matrix.test.ts. */
export const SETTINGS_DESTINATION_ROLE_AUTHORITY: Readonly<Record<string, readonly string[]>> = {
  '/settings/compliance': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'QUALITY_DIRECTOR',
    'FACILITY_MANAGER',
    'QUALITY_OFFICER',
    'COMPLIANCE_OFFICER',
  ],
  '/settings/document-templates': ['SYSTEM_ADMIN', 'TENANT_ADMIN', 'HR_DIRECTOR', 'HR_OFFICER'],
  '/settings/funding-authorisations': ['SYSTEM_ADMIN', 'TENANT_ADMIN', 'FINANCE_OFFICER'],
  '/settings/integrations': ['TENANT_ADMIN', 'OWNER'],
  '/settings/leave-policies': ['SYSTEM_ADMIN', 'TENANT_ADMIN'],
  '/settings/payroll/eba': ['SYSTEM_ADMIN', 'TENANT_ADMIN'],
  '/settings/payroll/eba/[ebaId]/rate-lines': ['SYSTEM_ADMIN', 'TENANT_ADMIN'],
  '/settings/payroll/pay-roles': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'FINANCE_OFFICER',
    'PAYROLL_OFFICER',
    'FACILITY_MANAGER',
  ],
  '/settings/payroll/pay-roles/prior-hours/[batchId]': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'FINANCE_OFFICER',
    'PAYROLL_OFFICER',
    'FACILITY_MANAGER',
  ],
  '/settings/payroll/profile': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'FINANCE_OFFICER',
    'PAYROLL_OFFICER',
  ],
  '/settings/payroll/provider-responsibilities': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'FINANCE_OFFICER',
    'PAYROLL_OFFICER',
  ],
  '/settings/payroll/worked-time-rules': ['SYSTEM_ADMIN', 'TENANT_ADMIN', 'COORDINATOR'],
  '/settings/people': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'CEO',
    'OWNER',
    'OPERATIONS_DIRECTOR',
    'HR_DIRECTOR',
    'REGION_MANAGER',
    'REGION_COMPLIANCE_OFFICER',
    'COORDINATOR',
    'TEAM_LEADER',
    'CLINICAL_LEAD',
    'FACILITY_MANAGER',
    'HR_OFFICER',
  ],
  '/settings/people/assignment-requirements': [
    'SYSTEM_ADMIN',
    'TENANT_ADMIN',
    'HR_DIRECTOR',
    'HR_OFFICER',
  ],
  '/settings/retention': ['SYSTEM_ADMIN', 'TENANT_ADMIN', 'QUALITY_OFFICER', 'COMPLIANCE_OFFICER'],
  '/settings/service-execution': ['SYSTEM_ADMIN', 'TENANT_ADMIN'],
};
